import { parseHTML } from '/js/utils/parseHTML';
import { handleModuleLoadingError } from './handleModuleLoadingError.js';

export const loadComparePopup = async function(customErrorHandling) {
    try {
        const popup = document.querySelector('#compare_popup');

        if (popup.hasAttribute('data-popup-loaded')) {
            const promise = import('/js/compare-popup').then(m => m.default);
            if (!customErrorHandling)
                promise.catch(handleModuleLoadingError);

            return promise;
        }

        const [m, response] = await Promise.all([
            import('/js/compare-popup'),
            fetch('/include/compare_popup.php', {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
        ]);

        if (!response.ok)
            throw new Error('Error loading #compare_popup content');

        popup.append(...parseHTML(await response.text()));
        popup.dataset.popupLoaded = true;

        // --- popup event handlers
        document
            .querySelector('.js-compare-popup .js-close-btn')
            ?.addEventListener('click', () => {
                document
                    .querySelector('.js-compare-popup')
                    ?.classList
                    .remove('is-shown');
            });

        return m.default;
    } catch(err) {
        if (err instanceof TypeError) {
            handleModuleLoadingError(err);
        }

        if (!(err instanceof Error)) {
            err = new Error(err?.toString() || 'Undefined error on loading compare popup');
        }

        return Promise.reject(err);
    }
};
